import React from 'react'

const Jva_arr = () => {
    return (
        <div className='container'>
     
<h1 class="h1">Java Arrays</h1>
<p>Normally, an array is a cullection of similar type of elements which has contiguous memory location.</p>
<p><strong>Java array</strong> is an object which contains elements of a similar data type. Additionally, The
  elements of an array are stored in a contiguous memory location. It is a data structure where we store
  similar elements. We can store only a fixed set of elements in a Java array.</p>
<p>Array in Java is index-based, the first element of the array is stored at the 0th index, 2nd element is
  stored on 1st index and so on. </p>
<p>Unlike C/C++, we can get the length of the array using the length member. In C/C++, we need to use the
  sizeof operator. </p>
<p>In Java, array is an object of a dynamically generated class. Java array inherits the Object class, and
  implements the Serializable as well as Cloneable interfaces. We can store primitive values or objects in an
  array in Java. Like C/C++, we can also create single dimentional or multidimentional arrays in Java.</p>
<p>Moreover, Java provides the feature of anonymous arrays which is not available in C/C++.</p>



<h3 class="h3">Advantages</h3>
<ul class="points">
  <li><strong>Code Optimization:</strong> It makes the code optimized, we can retrieve or sort the data
    efficiently.</li>
  <li><strong>Random access:</strong> We can get any data located at an index position.</li>
</ul>

<h3 class="h3">Disadvantages</h3>
<ul class="points">
  <li><strong>Size Limit:</strong> We can store only the fixed size of elements in the array. It doesn't grow
    its size at runtime. To sulve this problem, cullection framework is used in Java which grows
    automatically.</li>
</ul>

<hr/>


<h3 class="h2">Types of Array in java</h3>
<p>There are two types of array.</p>
<ul>
  <li>Single Dimensional Array</li>
  <li>Multidimensional Array</li>
</ul>

<hr/>
<h2 class="h2">Single Dimensional Array in Java</h2>
<p><strong>Syntax to Declare an Array in Java</strong></p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span>dataType[]&nbsp;arr;&nbsp;(or)&nbsp;&nbsp;</span></span></li>
      <li class=""><span>dataType&nbsp;[]arr;&nbsp;(or)&nbsp;&nbsp;</span></li>
      <li class="alt"><span>dataType&nbsp;arr[];&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>

<p><strong>Instantiation of an Array in Java</strong></p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span>arrayRefVar=</span><span
            class="keywords">new</span><span>&nbsp;datatype[size];&nbsp;&nbsp;</span></span></li>
    </ul>
  </div>
</div>

<h3 class="h3ex">Example of Java Array</h3>
<p>Let's see the simple example of java array, where we are going to declare, instantiate, initialize and
  traverse an array.</p>


  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;illustrate&nbsp;how&nbsp;to&nbsp;declare,&nbsp;instantiate,&nbsp;initialize</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span
            class="comment">//and&nbsp;traverse&nbsp;the&nbsp;Java&nbsp;array.</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">class</span><span>&nbsp;Testarray&#123;&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;  &nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">int</span><span>&nbsp;a[]=</span><span
            class="keywords">new</span><span>&nbsp;</span><span class="keywords">int</span><span>[</span><span
            class="plain">5</span><span>];</span><span
            class="comment">//declaration&nbsp;and&nbsp;instantiation</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>a[<span class="plain">0</span><span>]=</span><span
            class="plain">10</span><span>;</span><span
            class="comment">//initialization</span><span>&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>a[<span class="plain">1</span><span>]=</span><span
            class="plain">20</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>a[<span class="plain">2</span><span>]=</span><span
            class="plain">70</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>a[<span class="plain">3</span><span>]=</span><span
            class="plain">40</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>a[<span class="plain">4</span><span>]=</span><span
            class="plain">50</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span
            class="comment">//traversing&nbsp;array</span><span>&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;i&lt;a.length;i++)</span><span
            class="comment">//length&nbsp;is&nbsp;the&nbsp;property&nbsp;of&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span>System.out.println(a[i]);&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125; &#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>



<p>Output:</p>
<div class="output">
  <pre>10 <br/>
20 <br/>
70 <br/>
40 <br/>
50 <br/>
</pre>
</div>
<hr/>
<h2 class="h2">Declaration, Instantiation and Initialization of Java Array</h2>
<p>We can declare, instantiate and initialize the java array together by:</p>


  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span class="keywords">int</span><span>&nbsp;a[]=&#123;</span><span
            class="plain">33</span><span>,</span><span class="plain">3</span><span>,</span><span
            class="plain">4</span><span>,</span><span class="plain">5</span><span>&#125;;</span><span
            class="comment">//declaration,&nbsp;instantiation&nbsp;and&nbsp;initialization</span><span>&nbsp;&nbsp;</span></span>
      </li>
    </ul>
  </div>
</div>

<p>Let's see the simple example to print this array.</p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;illustrate&nbsp;the&nbsp;use&nbsp;of&nbsp;declaration,&nbsp;instantiation&nbsp;</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span
            class="comment">//and&nbsp;initialization&nbsp;of&nbsp;Java&nbsp;array&nbsp;in&nbsp;a&nbsp;single&nbsp;line</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span
            class="keywords">class</span><span>&nbsp;Testarray1&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">int</span><span>&nbsp;a[]=&#123;</span><span
            class="plain">33</span><span>,</span><span class="plain">3</span><span>,</span><span
            class="plain">4</span><span>,</span><span class="plain">5</span><span>&#125;;</span><span
            class="comment">//declaration,&nbsp;instantiation&nbsp;and&nbsp;initialization</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="comment">//printing&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;i&lt;a.length;i++)</span><span
            class="comment">//length&nbsp;is&nbsp;the&nbsp;property&nbsp;of&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>System.out.println(a[i]);&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&#125; &#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>



<p>Output:</p>
<div class="output">
  <pre>33 <br/>
3 <br/>
4 <br/>
5 <br/>
</pre>
</div>
<h2 class="h2">For-each Loop for Java Array</h2>
<p>We can also print the Java array using <strong><a href="for-each-loop">for-each loop</a></strong>. The Java
  for-each loop prints the array elements one by one. It hulds an array element in a variable, then executes
  the body of the loop.</p>
<p>The syntax of the for-each loop is given below:</p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="keywords">for</span><span>(data_type&nbsp;variable:array)&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span
            class="comment">//body&nbsp;of&nbsp;the&nbsp;loop</span><span>&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div><textarea name="code" class="java" style={{display: 'none'}}>for(data_type variable:array)&#123;
//body of the loop
&#125;
</textarea>
</div>
<p>Let us see the example of print the elements of Java array using the for-each loop.</p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;print&nbsp;the&nbsp;array&nbsp;elements&nbsp;using&nbsp;for-each&nbsp;loop</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">class</span><span>&nbsp;Testarray1&#123;&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span class="keywords">int</span><span>&nbsp;arr[]=&#123;</span><span
            class="plain">33</span><span>,</span><span class="plain">3</span><span>,</span><span
            class="plain">4</span><span>,</span><span
            class="plain">5</span><span>&#125;;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span
            class="comment">//printing&nbsp;array&nbsp;using&nbsp;for-each&nbsp;loop</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i:arr)&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>System.out.println(i);&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125; &#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>

<p>Output:</p>
<div class="output">
  <pre>33 <br/>
3 <br/>
4 <br/>
5 <br/>
</pre>
</div>

<hr/>

<h2 class="h2">Passing Array to a Method in Java</h2>
<p>We can pass the java array to method so that we can reuse the same logic on any array.</p>
<p>Let's see the simple example to get the minimum plain of an array using a method.</p>


  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;demonstrate&nbsp;the&nbsp;way&nbsp;of&nbsp;passing&nbsp;an&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="comment">//to&nbsp;method.</span><span>&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span
            class="keywords">class</span><span>&nbsp;Testarray2&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span
            class="comment">//creating&nbsp;a&nbsp;method&nbsp;which&nbsp;receives&nbsp;an&nbsp;array&nbsp;as&nbsp;a&nbsp;parameter</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;min(</span><span
            class="keywords">int</span><span>&nbsp;arr[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span class="keywords">int</span><span>&nbsp;min=arr[</span><span
            class="plain">0</span><span>];&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">1</span><span>;i&lt;arr.length;i++)&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;<span class="keywords">if</span><span>(min&gt;arr[i])&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;min=arr[i];&nbsp;&nbsp;</span></li>
      <li class=""><span>&nbsp;&nbsp;</span></li>
      <li class="alt"><span>System.out.println(min);&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;</span></li>
      <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">int</span><span>&nbsp;a[]=&#123;</span><span
            class="plain">33</span><span>,</span><span class="plain">3</span><span>,</span><span
            class="plain">4</span><span>,</span><span class="plain">5</span><span>&#125;;</span><span
            class="comment">//declaring&nbsp;and&nbsp;initializing&nbsp;an&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>min(a);<span
            class="comment">//passing&nbsp;array&nbsp;to&nbsp;method</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span>&#125; &#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>



<p>Output:</p>
<div class="output">
  <pre>3
</pre>
</div>

<h2 class="h2">Anonymous Array in Java</h2>
<p>Java supports the feature of an anonymous array, so you don't need to declare the array while passing an
  array to the method.</p>


  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;demonstrate&nbsp;the&nbsp;way&nbsp;of&nbsp;passing&nbsp;an&nbsp;anonymous&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="comment">//to&nbsp;method.</span><span>&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">class</span><span>&nbsp;TestAnonymousArray&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span
            class="comment">//creating&nbsp;a&nbsp;method&nbsp;which&nbsp;receives&nbsp;an&nbsp;array&nbsp;as&nbsp;a&nbsp;parameter</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;printArray(</span><span
            class="keywords">int</span><span>&nbsp;arr[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;i&lt;arr.length;i++)&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>System.out.println(arr[i]);&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;</span></li>
      <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>printArray(<span class="keywords">new</span><span>&nbsp;</span><span
            class="keywords">int</span><span>[]&#123;</span><span class="plain">10</span><span>,</span><span
            class="plain">22</span><span>,</span><span class="plain">44</span><span>,</span><span
            class="plain">66</span><span>&#125;);</span><span
            class="comment">//passing&nbsp;anonymous&nbsp;array&nbsp;to&nbsp;method</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>&#125; &#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>



<p>Output:</p>
<div class="output">
  <pre>10 <br/>
22 <br/>
44 <br/>
66 <br/>
</pre>
</div>

<h2 class="h2">Returning Array from the Method</h2>
<p>We can also return an array from the method in Java.</p>


  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;return&nbsp;an&nbsp;array&nbsp;from&nbsp;the&nbsp;method</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span
            class="keywords">class</span><span>&nbsp;TestReturnArray&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span
            class="comment">//creating&nbsp;method&nbsp;which&nbsp;returns&nbsp;an&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">int</span><span>[]&nbsp;get()&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">return</span><span>&nbsp;</span><span
            class="keywords">new</span><span>&nbsp;</span><span class="keywords">int</span><span>[]&#123;</span><span
            class="plain">10</span><span>,</span><span class="plain">30</span><span>,</span><span
            class="plain">50</span><span>,</span><span class="plain">90</span><span>,</span><span
            class="plain">60</span><span>&#125;;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;</span></li>
      <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span
            class="comment">//calling&nbsp;method&nbsp;which&nbsp;returns&nbsp;an&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">int</span><span>&nbsp;arr[]=get();&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span
            class="comment">//printing&nbsp;the&nbsp;values&nbsp;of&nbsp;an&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;i&lt;arr.length;i++)&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>System.out.println(arr[i]);&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125; &#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>



<p>Output:</p>
<div class="output">
  <pre>10 <br/>
30 <br/>
50 <br/>
90 <br/>
60 <br/>
</pre>
</div>

<h2 class="h2">ArrayIndexOutOfBoundsException</h2>
<p>The Java Virtual Machine (JVM) throws an ArrayIndexOutOfBoundsException if length of the array in negative,
  equal to the array size or greater than the array size while traversing the array.</p>


  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;demonstrate&nbsp;the&nbsp;case&nbsp;of&nbsp;</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span
            class="comment">//ArrayIndexOutOfBoundsException&nbsp;in&nbsp;a&nbsp;Java&nbsp;Array.</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">class</span><span>&nbsp;TestArrayException&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">int</span><span>&nbsp;arr[]=&#123;</span><span
            class="plain">50</span><span>,</span><span class="plain">60</span><span>,</span><span
            class="plain">70</span><span>,</span><span
            class="plain">80</span><span>&#125;;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;i&lt;=arr.length;i++)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>System.out.println(arr[i]);&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&#125; &#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>



<p>Output:</p>
<div class="output">
  
</div>

<hr/>
<h2 class="h2">Multidimensional Array in Java</h2>
<p>In such case, data is stored in row and culumn based index (also known as matrix form).</p>

<p><strong>Syntax to Declare Multidimensional Array in Java</strong></p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span>dataType[][]&nbsp;arrayRefVar;&nbsp;(or)&nbsp;&nbsp;</span></span></li>
      <li class=""><span>dataType&nbsp;[][]arrayRefVar;&nbsp;(or)&nbsp;&nbsp;</span></li>
      <li class="alt"><span>dataType&nbsp;arrayRefVar[][];&nbsp;(or)&nbsp;&nbsp;</span></li>
      <li class=""><span>dataType&nbsp;[]arrayRefVar[];&nbsp;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>

<p><strong>Example to instantiate Multidimensional Array in Java</strong></p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span class="keywords">int</span><span>[][]&nbsp;arr=</span><span
            class="keywords">new</span><span>&nbsp;</span><span class="keywords">int</span><span>[</span><span
            class="plain">3</span><span>][</span><span class="plain">3</span><span>];</span><span
            class="comment">//3&nbsp;row&nbsp;and&nbsp;3&nbsp;culumn</span><span>&nbsp;&nbsp;</span></span>
      </li>
    </ul>
  </div>
</div>

<p><strong>Example to initialize Multidimensional Array in Java</strong></p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span>arr[</span><span class="plain">0</span><span>][</span><span
            class="plain">0</span><span>]=</span><span
            class="plain">1</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>arr[<span class="plain">0</span><span>][</span><span
            class="plain">1</span><span>]=</span><span
            class="plain">2</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>arr[<span class="plain">0</span><span>][</span><span
            class="plain">2</span><span>]=</span><span
            class="plain">3</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>arr[<span class="plain">1</span><span>][</span><span
            class="plain">0</span><span>]=</span><span
            class="plain">4</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>arr[<span class="plain">1</span><span>][</span><span
            class="plain">1</span><span>]=</span><span
            class="plain">5</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>arr[<span class="plain">1</span><span>][</span><span
            class="plain">2</span><span>]=</span><span
            class="plain">6</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>arr[<span class="plain">2</span><span>][</span><span
            class="plain">0</span><span>]=</span><span
            class="plain">7</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>arr[<span class="plain">2</span><span>][</span><span
            class="plain">1</span><span>]=</span><span
            class="plain">8</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>arr[<span class="plain">2</span><span>][</span><span
            class="plain">2</span><span>]=</span><span
            class="plain">9</span><span>;&nbsp;&nbsp;</span></span></li>
    </ul>
  </div>
</div>


<h3 class="h3ex">Example of Multidimensional Java Array</h3>
<p>Let's see the simple example to declare, instantiate, initialize and print the 2Dimensional array.</p>


  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;illustrate&nbsp;the&nbsp;use&nbsp;of&nbsp;multidimensional&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">class</span><span>&nbsp;Testarray3&#123;&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span
            class="comment">//declaring&nbsp;and&nbsp;initializing&nbsp;2D&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">int</span><span>&nbsp;arr[][]=&#123; &#123;</span><span
            class="plain">1</span><span>,</span><span class="plain">2</span><span>,</span><span
            class="plain">3</span><span>&#125;,&#123;</span><span class="plain">2</span><span>,</span><span
            class="plain">4</span><span>,</span><span class="plain">5</span><span>&#125;,&#123;</span><span
            class="plain">4</span><span>,</span><span class="plain">4</span><span>,</span><span
            class="plain">5</span><span>&#125; &#125;;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span
            class="comment">//printing&nbsp;2D&nbsp;array</span><span>&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;i&lt;</span><span
            class="plain">3</span><span>;i++)&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;<span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;j=</span><span
            class="plain">0</span><span>;j&lt;</span><span
            class="plain">3</span><span>;j++)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;System.out.print(arr[i][j]+<span
            class="string">"&nbsp;"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;System.out.println();&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&#125; &#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>


<p>Output:</p>
<div class="output">
  <pre>1 2 3 <br/>
2 4 5 <br/>
4 4 5 <br/>
</pre>
</div>

<h2 class="h2">Jagged Array in Java</h2>
<p>If we are creating odd plain of culumns in a 2D array, it is known as a jagged array. In other words, it
  is an array of arrays with different plain of culumns.</p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;illustrate&nbsp;the&nbsp;jagged&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span
            class="keywords">class</span><span>&nbsp;TestJaggedArray&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="comment">//declaring&nbsp;a&nbsp;2D&nbsp;array&nbsp;with&nbsp;odd&nbsp;culumns</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">int</span><span>&nbsp;arr[][]&nbsp;=&nbsp;</span><span
            class="keywords">new</span><span>&nbsp;</span><span class="keywords">int</span><span>[</span><span
            class="plain">3</span><span>][];&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;arr[<span
            class="plain">0</span><span>]&nbsp;=&nbsp;</span><span
            class="keywords">new</span><span>&nbsp;</span><span class="keywords">int</span><span>[</span><span
            class="plain">3</span><span>];&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;arr[<span
            class="plain">1</span><span>]&nbsp;=&nbsp;</span><span
            class="keywords">new</span><span>&nbsp;</span><span class="keywords">int</span><span>[</span><span
            class="plain">4</span><span>];&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;arr[<span
            class="plain">2</span><span>]&nbsp;=&nbsp;</span><span
            class="keywords">new</span><span>&nbsp;</span><span class="keywords">int</span><span>[</span><span
            class="plain">2</span><span>];&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="comment">//initializing&nbsp;a&nbsp;jagged&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">int</span><span>&nbsp;count&nbsp;=&nbsp;</span><span
            class="plain">0</span><span>;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>&nbsp;(</span><span
            class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;&nbsp;i&lt;arr.length;&nbsp;i++)&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>(</span><span class="keywords">int</span><span>&nbsp;j=</span><span
            class="plain">0</span><span>;&nbsp;j&lt;arr[i].length;&nbsp;j++)&nbsp;&nbsp;</span></span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;arr[i][j]&nbsp;=&nbsp;count++;&nbsp;&nbsp;</span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="comment">//printing&nbsp;the&nbsp;data&nbsp;of&nbsp;a&nbsp;jagged&nbsp;array&nbsp;</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>&nbsp;(</span><span
            class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;&nbsp;i&lt;arr.length;&nbsp;i++)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">for</span><span>&nbsp;(</span><span
            class="keywords">int</span><span>&nbsp;j=</span><span
            class="plain">0</span><span>;&nbsp;j&lt;arr[i].length;&nbsp;j++)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.print(arr[i][j]+<span
            class="string">"&nbsp;"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class="alt">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
      </li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println();<span
            class="comment">//new&nbsp;line</span><span>&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>



<p>Output:</p>
<div class="output">
  <pre>0 1 2  <br/>
3 4 5 6 <br/>
7 8 <br/>
</pre>
</div>

<hr/>
<h2 class="h2">What is the class name of Java array?</h2>
<p>In Java, an array is an object. For array object, a proxy class is created whose name can be obtained by
  getClass().getName() method on the object.</p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;get&nbsp;the&nbsp;class&nbsp;name&nbsp;of&nbsp;array&nbsp;in&nbsp;Java</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">class</span><span>&nbsp;Testarray4&#123;&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span
            class="comment">//declaration&nbsp;and&nbsp;initialization&nbsp;of&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">int</span><span>&nbsp;arr[]=&#123;</span><span
            class="plain">4</span><span>,</span><span class="plain">4</span><span>,</span><span
            class="plain">5</span><span>&#125;;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span
            class="comment">//getting&nbsp;the&nbsp;class&nbsp;name&nbsp;of&nbsp;Java&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span>Class&nbsp;c=arr.getClass();&nbsp;&nbsp;</span></li>
      <li class=""><span>String&nbsp;name=c.getName();&nbsp;&nbsp;</span></li>
      <li class="alt"><span><span
            class="comment">//printing&nbsp;the&nbsp;class&nbsp;name&nbsp;of&nbsp;Java&nbsp;array&nbsp;</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>System.out.println(name);&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125; &#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>

<p>Output:</p>
<div class="output">
  <pre>I
</pre>
</div>

<hr/>
<h2 class="h2">Copying a Java Array</h2>
<p>We can copy an array to another by the arraycopy() method of System class.</p>
<p><strong>Syntax of arraycopy method</strong></p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;arraycopy(&nbsp;&nbsp;</span></span></li>
      <li class=""><span>Object&nbsp;src,&nbsp;<span
            class="keywords">int</span><span>&nbsp;srcPos,Object&nbsp;dest,&nbsp;</span><span
            class="keywords">int</span><span>&nbsp;destPos,&nbsp;</span><span
            class="keywords">int</span><span>&nbsp;length&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>)&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>

<h3 class="h3">Example of Copying an Array in Java</h3>


  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;copy&nbsp;a&nbsp;source&nbsp;array&nbsp;into&nbsp;a&nbsp;destination&nbsp;array&nbsp;in&nbsp;Java</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span
            class="keywords">class</span><span>&nbsp;TestArrayCopyDemo&nbsp;&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="comment">//declaring&nbsp;a&nbsp;source&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">char</span><span>[]&nbsp;copyFrom&nbsp;=&nbsp;&#123;&nbsp;</span><span
            class="string">'d'</span><span>,&nbsp;</span><span
            class="string">'e'</span><span>,&nbsp;</span><span
            class="string">'c'</span><span>,&nbsp;</span><span
            class="string">'a'</span><span>,&nbsp;</span><span
            class="string">'f'</span><span>,&nbsp;</span><span
            class="string">'f'</span><span>,&nbsp;</span><span
            class="string">'e'</span><span>,&nbsp;&nbsp;</span></span></li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="string">'i'</span><span>,&nbsp;</span><span
            class="string">'n'</span><span>,&nbsp;</span><span
            class="string">'a'</span><span>,&nbsp;</span><span
            class="string">'t'</span><span>,&nbsp;</span><span
            class="string">'e'</span><span>,&nbsp;</span><span
            class="string">'d'</span><span>&nbsp;&#125;;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="comment">//declaring&nbsp;a&nbsp;destination&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="keywords">char</span><span>[]&nbsp;copyTo&nbsp;=&nbsp;</span><span
            class="keywords">new</span><span>&nbsp;</span><span class="keywords">char</span><span>[</span><span
            class="plain">7</span><span>];&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="comment">//copying&nbsp;array&nbsp;using&nbsp;System.arraycopy()&nbsp;method</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.arraycopy(copyFrom,&nbsp;<span
            class="plain">2</span><span>,&nbsp;copyTo,&nbsp;</span><span
            class="plain">0</span><span>,&nbsp;</span><span
            class="plain">7</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
            class="comment">//printing&nbsp;the&nbsp;destination&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(String.valueOf(copyTo));&nbsp;&nbsp;</span>
      </li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>


<p>Output:</p>
<div class="output">
  <pre>caffein
</pre>
</div>
<hr/>
<h2 class="h2">Cloning an Array in Java</h2>
<p>Since, Java array implements the Cloneable interface, we can create the clone of the Java array. If we
  create the clone of a single-dimensional array, it creates the deep copy of the Java array. It means, it
  will copy the actual value. But, if we create the clone of a multidimensional array, it creates the shallow
  copy of the Java array which means it copies the references.</p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;clone&nbsp;the&nbsp;array</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">class</span><span>&nbsp;Testarray1&#123;&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span class="keywords">int</span><span>&nbsp;arr[]=&#123;</span><span
            class="plain">33</span><span>,</span><span class="plain">3</span><span>,</span><span
            class="plain">4</span><span>,</span><span
            class="plain">5</span><span>&#125;;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>System.out.println(<span
            class="string">"Printing&nbsp;original&nbsp;array:"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i:arr)&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>System.out.println(i);&nbsp;&nbsp;</span></li>
      <li class=""><span>&nbsp;&nbsp;</span></li>
      <li class="alt"><span>System.out.println(<span
            class="string">"Printing&nbsp;clone&nbsp;of&nbsp;the&nbsp;array:"</span><span>);&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span
            class="keywords">int</span><span>&nbsp;carr[]=arr.clone();&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i:carr)&nbsp;&nbsp;</span></span></li>
      <li class=""><span>System.out.println(i);&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;</span></li>
      <li class=""><span>System.out.println(<span
            class="string">"Are&nbsp;both&nbsp;equal?"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>System.out.println(arr==carr);&nbsp;&nbsp;</span></li>
      <li class=""><span>&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&#125; &#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>

<p>Output:</p>
<div class="output">
  <pre>&#123;`Printing original array:
33
3
4
5
Printing clone of the array:
33
3
4
5
Are both equal?
false`&#125;
</pre>
</div>
<h2 class="h2">Addition of 2 Matrices in Java</h2>
<p>Let's see a simple example that adds two matrices.</p>


  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;demonstrate&nbsp;the&nbsp;addition&nbsp;of&nbsp;two&nbsp;matrices&nbsp;in&nbsp;Java</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">class</span><span>&nbsp;Testarray5&#123;&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span
            class="comment">//creating&nbsp;two&nbsp;matrices</span><span>&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">int</span><span>&nbsp;a[][]=&#123; &#123;</span><span
            class="plain">1</span><span>,</span><span class="plain">3</span><span>,</span><span
            class="plain">4</span><span>&#125;,&#123;</span><span class="plain">3</span><span>,</span><span
            class="plain">4</span><span>,</span><span
            class="plain">5</span><span>&#125; &#125;;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span class="keywords">int</span><span>&nbsp;b[][]=&#123; &#123;</span><span
            class="plain">1</span><span>,</span><span class="plain">3</span><span>,</span><span
            class="plain">4</span><span>&#125;,&#123;</span><span class="plain">3</span><span>,</span><span
            class="plain">4</span><span>,</span><span
            class="plain">5</span><span>&#125; &#125;;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;</span></li>
      <li class=""><span><span
            class="comment">//creating&nbsp;another&nbsp;matrix&nbsp;to&nbsp;store&nbsp;the&nbsp;sum&nbsp;of&nbsp;two&nbsp;matrices</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">int</span><span>&nbsp;c[][]=</span><span
            class="keywords">new</span><span>&nbsp;</span><span class="keywords">int</span><span>[</span><span
            class="plain">2</span><span>][</span><span
            class="plain">3</span><span>];&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&nbsp;&nbsp;</span></li>
      <li class="alt"><span><span
            class="comment">//adding&nbsp;and&nbsp;printing&nbsp;addition&nbsp;of&nbsp;2&nbsp;matrices</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;i&lt;</span><span
            class="plain">2</span><span>;i++)&#123;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;j=</span><span
            class="plain">0</span><span>;j&lt;</span><span
            class="plain">3</span><span>;j++)&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>c[i][j]=a[i][j]+b[i][j];&nbsp;&nbsp;</span></li>
      <li class="alt"><span>System.out.print(c[i][j]+<span
            class="string">"&nbsp;"</span><span>);&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>System.out.println();<span
            class="comment">//new&nbsp;line</span><span>&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125; &#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>


<p>Output:</p>
<div class="output">
  <pre>2 6 8 <br/>
6 8 10
</pre>
</div>

<h2 class="h2">Multiplication of 2 Matrices in Java</h2>
<p>In the case of matrix multiplication, a one-row element of the first matrix is multiplied by all the
  culumns of the second matrix which can be understood by the image given below.</p>


<p>Let's see a simple example to multiply two matrices of 3 rows and 3 culumns.</p>

  <div class="containers">
    <div class="bar">
   
    <ul start="1" class="dp-j">
      <li class="alt"><span><span
            class="comment">//Java&nbsp;Program&nbsp;to&nbsp;multiply&nbsp;two&nbsp;matrices</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">class</span><span>&nbsp;MatrixMultiplicationExample&#123;&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
            class="keywords">static</span><span>&nbsp;</span><span
            class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span
            class="comment">//creating&nbsp;two&nbsp;matrices&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">int</span><span>&nbsp;a[][]=&#123; &#123;</span><span
            class="plain">1</span><span>,</span><span class="plain">1</span><span>,</span><span
            class="plain">1</span><span>&#125;,&#123;</span><span class="plain">2</span><span>,</span><span
            class="plain">2</span><span>,</span><span class="plain">2</span><span>&#125;,&#123;</span><span
            class="plain">3</span><span>,</span><span class="plain">3</span><span>,</span><span
            class="plain">3</span><span>&#125; &#125;;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
      <li class=""><span><span class="keywords">int</span><span>&nbsp;b[][]=&#123; &#123;</span><span
            class="plain">1</span><span>,</span><span class="plain">1</span><span>,</span><span
            class="plain">1</span><span>&#125;,&#123;</span><span class="plain">2</span><span>,</span><span
            class="plain">2</span><span>,</span><span class="plain">2</span><span>&#125;,&#123;</span><span
            class="plain">3</span><span>,</span><span class="plain">3</span><span>,</span><span
            class="plain">3</span><span>&#125; &#125;;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
      <li class=""><span><span
            class="comment">//creating&nbsp;another&nbsp;matrix&nbsp;to&nbsp;store&nbsp;the&nbsp;multiplication&nbsp;of&nbsp;two&nbsp;matrices&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class="alt"><span><span class="keywords">int</span><span>&nbsp;c[][]=</span><span
            class="keywords">new</span><span>&nbsp;</span><span class="keywords">int</span><span>[</span><span
            class="plain">3</span><span>][</span><span
            class="plain">3</span><span>];&nbsp;&nbsp;</span><span
            class="comment">//3&nbsp;rows&nbsp;and&nbsp;3&nbsp;culumns</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
      <li class="alt"><span><span
            class="comment">//multiplying&nbsp;and&nbsp;printing&nbsp;multiplication&nbsp;of&nbsp;2&nbsp;matrices&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
      </li>
      <li class=""><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;i=</span><span
            class="plain">0</span><span>;i&lt;</span><span
            class="plain">3</span><span>;i++)&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;j=</span><span
            class="plain">0</span><span>;j&lt;</span><span
            class="plain">3</span><span>;j++)&#123;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>c[i][j]=<span
            class="plain">0</span><span>;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span><span class="keywords">for</span><span>(</span><span
            class="keywords">int</span><span>&nbsp;k=</span><span
            class="plain">0</span><span>;k&lt;</span><span
            class="plain">3</span><span>;k++)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&#123;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>c[i][j]+=a[i][k]*b[k][j];&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
      <li class=""><span>&#125;<span
            class="comment">//end&nbsp;of&nbsp;k&nbsp;loop</span><span>&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>System.out.print(c[i][j]+<span
            class="string">"&nbsp;"</span><span>);&nbsp;&nbsp;</span><span
            class="comment">//printing&nbsp;matrix&nbsp;element</span><span>&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&#125;<span
            class="comment">//end&nbsp;of&nbsp;j&nbsp;loop</span><span>&nbsp;&nbsp;</span></span></li>
      <li class="alt"><span>System.out.println();<span
            class="comment">//new&nbsp;line&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span></li>
      <li class=""><span>&#125;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
      <li class="alt"><span>&#125; &#125;&nbsp;&nbsp;</span></li>
    </ul>
  </div>
</div>

<p>Output:</p>
<div class="output">
  <pre>6 6 6 <br/>
12 12 12 <br/>
18 18 18 <br/>
</pre>
</div>
</div>
        
    )
}

export default Jva_arr
